var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRestaurantForkKnife(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99866 1V31",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9987 1V10C12.9955 11.0599 12.573 12.0755 11.8236 12.8249C11.0741 13.5744 10.0585 13.9968 8.99866 14C7.93876 13.9968 6.92319 13.5744 6.17373 12.8249C5.42427 12.0755 5.00182 11.0599 4.99866 10V1",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9986 21H24.9986C25.264 21.0101 25.5286 20.9653 25.7758 20.8683C26.023 20.7714 26.2476 20.6245 26.4353 20.4367C26.6231 20.2489 26.7701 20.0244 26.867 19.7772C26.9639 19.5299 27.0088 19.2653 26.9986 19C26.784 13.256 26.552 7.23999 22.848 1.45732C22.7292 1.27641 22.5554 1.13851 22.3522 1.06403C22.149 0.989544 21.9273 0.982429 21.7197 1.04373C21.5122 1.10504 21.3299 1.23151 21.1998 1.40444C21.0697 1.57737 20.9987 1.78759 20.9973 2.00399V31",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurantForkKnife);
export default __webpack_public_path__ + "static/media/RestaurantForkKnife.04d220ea27d94e14c5a9c631b616f9d4.svg";
export { ForwardRef as ReactComponent };